export const INITIAL_FILTER_STATE = {
  experienceTitle: [],
  dateRange: null,
  source: '',
  medium: '',
  keySkills: [],
  locations: [],
  experienceStart: null,
  experienceEnd: null,
  pgGradeStart: null,
  pgGradeEnd: null,
  ugGradeStart: null,
  ugGradeEnd: null,
  degrees: [],
  majors: [],
  colleges: [],
  institutions: [],
  industries: [],
  chatInvite: [],
  currentCompanies: [],
  companies: [],
  keywords: [],
  skills: [],
  skillsBool: false,
  booleanSkills: '',
  keywordsBool: false,
  booleanKeywords: '',
  activeLooking: false,
  tags: [],
  includedTagIds: [],
  excludedTagIds: [],
  resumeCategory: '',
  currentCtcStart: null,
  savedFilterId: -1,
  quickPromptFilterId: -1,
  currentCtcEnd: null,
  expectedCtcStart: null,
  expectedCtcEnd: null,
  currentCtcCurrency: '',
  expectedCtcCurrency: '',
  noticePeriod: null,
  noticePeriodStart: null,
  noticePeriodEnd: null,
  preferredLocations: [],
  names: [],
  emails: [],
  phones: [],
  candidateIds: '',
  q: [],
  gender: [],
  includedTalentPoolIds: [],
  excludedTalentPoolIds: [],
  subStatusIds: [],
} as const;

export const INITIAL_FILTER_PAYLOAD = {
  type: 'applied',
  sort: 'overall',
  sortBy: 'OVERALL_SCORE',
  sortOrder: 'DESC',
  filter: INITIAL_FILTER_STATE,
  weightage: null,
  pageSize: 10,
  page: 0,
} as const;

export const INITIAL_FILTER_WEIGHTAGE = {
  skill: 5,
  experience: 5,
  education: 5,
} as const;
